import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import awsConfig from "./aws-exports";

// Cognito Auth Configuration
const cognitoAuthConfig = {
  authority: `https://${awsConfig.authority}`, // Cognito domain
  client_id: awsConfig.client_id, // App Client ID
  redirect_uri: awsConfig.redirect_uri, // Redirect URI after login
  response_type: awsConfig.response_type, // OAuth response type
  scope: awsConfig.scope, // OAuth scopes
};

// Log the Cognito Config for debugging
console.log("Cognito Config:", cognitoAuthConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
